import { map } from 'nanostores';

// import resolveConfig from 'tailwindcss/resolveConfig';
// import tailwindConfig from '../../../tailwind.config.js';

// Resolve Tailwind config
// const fullConfig = resolveConfig(tailwindConfig);

// =============================================================================
// Breakpoints
// =============================================================================
const $breakpoints = map({
  sm: '991px'
});

// =============================================================================
// MediaQueries
// =============================================================================
const $mediaQueries = map({
  reducedMotion: `(prefers-reduced-motion: reduce)`,
  touchScreen: `(hover: none)`,
  touchOrSmall: `(max-width: ${
    Number($breakpoints.get().sm.replace('px', '')) - 1
  }px), (hover: none)`,
  small: `(max-width: ${Number($breakpoints.get().sm.replace('px', '')) - 1}px)`
});

// =============================================================================
// States
// =============================================================================
const mediaStatusQueries = {
  reducedMotion: matchMedia($mediaQueries.get().reducedMotion || ''),
  touchScreen: matchMedia($mediaQueries.get().touchScreen || ''),
  touchOrSmall: matchMedia($mediaQueries.get().touchOrSmall || ''),
  small: matchMedia($mediaQueries.get().small || '')
};

export const $mediaStatus = map({
  isReducedMotion: mediaStatusQueries.reducedMotion.matches,
  isTouchScreen: mediaStatusQueries.touchScreen.matches,
  isTouchOrSmall: mediaStatusQueries.touchOrSmall.matches,
  isSmall: mediaStatusQueries.small.matches
});

for (const mediaQuery in mediaStatusQueries) {
  mediaStatusQueries[mediaQuery].addEventListener('change', () => {
    const property = `is${mediaQuery.charAt(0).toUpperCase()}${mediaQuery.slice(1)}`;
    $mediaStatus.setKey(property, mediaStatusQueries[mediaQuery].matches);
  });
}
